import * as X from "react";
import Kr, { forwardRef as dr, useContext as Wt, useState as Zr, useRef as Xr, useEffect as Qr, useImperativeHandle as zt, useMemo as Ut } from "react";
import { animate as Bt } from "framer-motion";
import { Skeleton as qt } from "@illa-design/skeleton";
import se from "dayjs";
import { css as fe } from "@emotion/react";
import { globalColor as pr, illaPrefix as vr, applyBoxStyle as et, deleteCssProps as rt } from "@illa-design/theme";
import { isObject as Ir } from "@illa-design/system";
var ir = { exports: {} }, ge = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Gt() {
  if (Dr)
    return ge;
  Dr = 1;
  var e = Kr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, d, h) {
    var p, y = {}, R = null, N = null;
    h !== void 0 && (R = "" + h), d.key !== void 0 && (R = "" + d.key), d.ref !== void 0 && (N = d.ref);
    for (p in d)
      a.call(d, p) && !i.hasOwnProperty(p) && (y[p] = d[p]);
    if (l && l.defaultProps)
      for (p in d = l.defaultProps, d)
        y[p] === void 0 && (y[p] = d[p]);
    return { $$typeof: r, type: l, key: R, ref: N, props: y, _owner: o.current };
  }
  return ge.Fragment = n, ge.jsx = u, ge.jsxs = u, ge;
}
var be = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function Ht() {
  return Mr || (Mr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Kr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), C = Symbol.iterator, g = "@@iterator";
    function A(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = C && t[C] || t[g];
      return typeof s == "function" ? s : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), E = 1; E < s; E++)
          f[E - 1] = arguments[E];
        S("error", t, f);
      }
    }
    function S(t, s, f) {
      {
        var E = b.ReactDebugCurrentFrame, T = E.getStackAddendum();
        T !== "" && (s += "%s", f = f.concat([T]));
        var D = f.map(function(x) {
          return String(x);
        });
        D.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var M = !1, c = !1, I = !1, w = !1, He = !1, Ce;
    Ce = Symbol.for("react.module.reference");
    function Je(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || He || t === o || t === h || t === p || w || t === N || M || c || I || typeof t == "object" && t !== null && (t.$$typeof === R || t.$$typeof === y || t.$$typeof === u || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Ce || t.getModuleId !== void 0));
    }
    function Ke(t, s, f) {
      var E = t.displayName;
      if (E)
        return E;
      var T = s.displayName || s.name || "";
      return T !== "" ? f + "(" + T + ")" : f;
    }
    function Te(t) {
      return t.displayName || "Context";
    }
    function q(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Te(s) + ".Consumer";
          case u:
            var f = t;
            return Te(f._context) + ".Provider";
          case d:
            return Ke(t, t.render, "ForwardRef");
          case y:
            var E = t.displayName || null;
            return E !== null ? E : q(t.type) || "Memo";
          case R: {
            var T = t, D = T._payload, x = T._init;
            try {
              return q(x(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ee = 0, Oe, Pe, de, Ne, pe, Ae, $e;
    function ke() {
    }
    ke.__reactDisabledLog = !0;
    function Ze() {
      {
        if (ee === 0) {
          Oe = console.log, Pe = console.info, de = console.warn, Ne = console.error, pe = console.group, Ae = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: ke,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Xe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: Oe
            }),
            info: K({}, t, {
              value: Pe
            }),
            warn: K({}, t, {
              value: de
            }),
            error: K({}, t, {
              value: Ne
            }),
            group: K({}, t, {
              value: pe
            }),
            groupCollapsed: K({}, t, {
              value: Ae
            }),
            groupEnd: K({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = b.ReactCurrentDispatcher, he;
    function te(t, s, f) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (T) {
            var E = T.stack.trim().match(/\n( *(at )?)/);
            he = E && E[1] || "";
          }
        return `
` + he + t;
      }
    }
    var me = !1, ne;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new Qe();
    }
    function v(t, s) {
      if (!t || me)
        return "";
      {
        var f = ne.get(t);
        if (f !== void 0)
          return f;
      }
      var E;
      me = !0;
      var T = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = ve.current, ve.current = null, Ze();
      try {
        if (s) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (Z) {
              E = Z;
            }
            Reflect.construct(t, [], x);
          } else {
            try {
              x.call();
            } catch (Z) {
              E = Z;
            }
            t.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            E = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && E && typeof Z.stack == "string") {
          for (var _ = Z.stack.split(`
`), W = E.stack.split(`
`), F = _.length - 1, j = W.length - 1; F >= 1 && j >= 0 && _[F] !== W[j]; )
            j--;
          for (; F >= 1 && j >= 0; F--, j--)
            if (_[F] !== W[j]) {
              if (F !== 1 || j !== 1)
                do
                  if (F--, j--, j < 0 || _[F] !== W[j]) {
                    var B = `
` + _[F].replace(" at new ", " at ");
                    return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), typeof t == "function" && ne.set(t, B), B;
                  }
                while (F >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        me = !1, ve.current = D, Xe(), Error.prepareStackTrace = T;
      }
      var ie = t ? t.displayName || t.name : "", kr = ie ? te(ie) : "";
      return typeof t == "function" && ne.set(t, kr), kr;
    }
    function ye(t, s, f) {
      return v(t, !1);
    }
    function ae(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function re(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ae(t));
      if (typeof t == "string")
        return te(t);
      switch (t) {
        case h:
          return te("Suspense");
        case p:
          return te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return ye(t.render);
          case y:
            return re(t.type, s, f);
          case R: {
            var E = t, T = E._payload, D = E._init;
            try {
              return re(D(T), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, _r = {}, Sr = b.ReactDebugCurrentFrame;
    function De(t) {
      if (t) {
        var s = t._owner, f = re(t.type, t._source, s ? s.type : null);
        Sr.setExtraStackFrame(f);
      } else
        Sr.setExtraStackFrame(null);
    }
    function St(t, s, f, E, T) {
      {
        var D = Function.call.bind(Ie);
        for (var x in t)
          if (D(t, x)) {
            var _ = void 0;
            try {
              if (typeof t[x] != "function") {
                var W = Error((E || "React class") + ": " + f + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              _ = t[x](s, x, E, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              _ = F;
            }
            _ && !(_ instanceof Error) && (De(T), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", f, x, typeof _), De(null)), _ instanceof Error && !(_.message in _r) && (_r[_.message] = !0, De(T), m("Failed %s type: %s", f, _.message), De(null));
          }
      }
    }
    var wt = Array.isArray;
    function er(t) {
      return wt(t);
    }
    function xt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function Rt(t) {
      try {
        return wr(t), !1;
      } catch {
        return !0;
      }
    }
    function wr(t) {
      return "" + t;
    }
    function xr(t) {
      if (Rt(t))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xt(t)), wr(t);
    }
    var Ee = b.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rr, Cr, rr;
    rr = {};
    function Tt(t) {
      if (Ie.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Ot(t) {
      if (Ie.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Pt(t, s) {
      if (typeof t.ref == "string" && Ee.current && s && Ee.current.stateNode !== s) {
        var f = q(Ee.current.type);
        rr[f] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(Ee.current.type), t.ref), rr[f] = !0);
      }
    }
    function Nt(t, s) {
      {
        var f = function() {
          Rr || (Rr = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function At(t, s) {
      {
        var f = function() {
          Cr || (Cr = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var $t = function(t, s, f, E, T, D, x) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: x,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function kt(t, s, f, E, T) {
      {
        var D, x = {}, _ = null, W = null;
        f !== void 0 && (xr(f), _ = "" + f), Ot(s) && (xr(s.key), _ = "" + s.key), Tt(s) && (W = s.ref, Pt(s, T));
        for (D in s)
          Ie.call(s, D) && !Ct.hasOwnProperty(D) && (x[D] = s[D]);
        if (t && t.defaultProps) {
          var F = t.defaultProps;
          for (D in F)
            x[D] === void 0 && (x[D] = F[D]);
        }
        if (_ || W) {
          var j = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && Nt(x, j), W && At(x, j);
        }
        return $t(t, _, W, T, E, Ee.current, x);
      }
    }
    var tr = b.ReactCurrentOwner, Tr = b.ReactDebugCurrentFrame;
    function oe(t) {
      if (t) {
        var s = t._owner, f = re(t.type, t._source, s ? s.type : null);
        Tr.setExtraStackFrame(f);
      } else
        Tr.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function ar(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Or() {
      {
        if (tr.current) {
          var t = q(tr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function It(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var Pr = {};
    function Dt(t) {
      {
        var s = Or();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Nr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = Dt(s);
        if (Pr[f])
          return;
        Pr[f] = !0;
        var E = "";
        t && t._owner && t._owner !== tr.current && (E = " It was passed a child from " + q(t._owner.type) + "."), oe(t), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, E), oe(null);
      }
    }
    function Ar(t, s) {
      {
        if (typeof t != "object")
          return;
        if (er(t))
          for (var f = 0; f < t.length; f++) {
            var E = t[f];
            ar(E) && Nr(E, s);
          }
        else if (ar(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var T = A(t);
          if (typeof T == "function" && T !== t.entries)
            for (var D = T.call(t), x; !(x = D.next()).done; )
              ar(x.value) && Nr(x.value, s);
        }
      }
    }
    function Mt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          f = s.propTypes;
        else
          return;
        if (f) {
          var E = q(s);
          St(f, t.props, "prop", E, t);
        } else if (s.PropTypes !== void 0 && !nr) {
          nr = !0;
          var T = q(s);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ft(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var E = s[f];
          if (E !== "children" && E !== "key") {
            oe(t), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), oe(null);
            break;
          }
        }
        t.ref !== null && (oe(t), m("Invalid attribute `ref` supplied to `React.Fragment`."), oe(null));
      }
    }
    function $r(t, s, f, E, T, D) {
      {
        var x = Je(t);
        if (!x) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = It(T);
          W ? _ += W : _ += Or();
          var F;
          t === null ? F = "null" : er(t) ? F = "array" : t !== void 0 && t.$$typeof === r ? (F = "<" + (q(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : F = typeof t, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, _);
        }
        var j = kt(t, s, f, T, D);
        if (j == null)
          return j;
        if (x) {
          var B = s.children;
          if (B !== void 0)
            if (E)
              if (er(B)) {
                for (var ie = 0; ie < B.length; ie++)
                  Ar(B[ie], t);
                Object.freeze && Object.freeze(B);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ar(B, t);
        }
        return t === a ? Ft(j) : Mt(j), j;
      }
    }
    function jt(t, s, f) {
      return $r(t, s, f, !0);
    }
    function Vt(t, s, f) {
      return $r(t, s, f, !1);
    }
    var Yt = Vt, Lt = jt;
    be.Fragment = a, be.jsx = Yt, be.jsxs = Lt;
  }()), be;
}
process.env.NODE_ENV === "production" ? ir.exports = Gt() : ir.exports = Ht();
var Le = ir.exports;
function Jt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Kt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Zt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Kt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var u = Jt(o);
      try {
        u.insertRule(a, u.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", We = "-moz-", O = "-webkit-", hr = "comm", mr = "rule", yr = "decl", Xt = "@import", tt = "@keyframes", Qt = "@layer", en = Math.abs, Ue = String.fromCharCode, rn = Object.assign;
function tn(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function nt(e) {
  return e.trim();
}
function nn(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function P(e, r, n) {
  return e.replace(r, n);
}
function sr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function Se(e, r, n) {
  return e.slice(r, n);
}
function H(e) {
  return e.length;
}
function Er(e) {
  return e.length;
}
function Me(e, r) {
  return r.push(e), e;
}
function an(e, r) {
  return e.map(r).join("");
}
var Be = 1, ue = 1, at = 0, z = 0, V = 0, le = "";
function qe(e, r, n, a, o, i, u) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Be, column: ue, length: u, return: "" };
}
function _e(e, r) {
  return rn(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function on() {
  return V;
}
function sn() {
  return V = z > 0 ? Y(le, --z) : 0, ue--, V === 10 && (ue = 1, Be--), V;
}
function U() {
  return V = z < at ? Y(le, z++) : 0, ue++, V === 10 && (ue = 1, Be++), V;
}
function J() {
  return Y(le, z);
}
function Fe() {
  return z;
}
function Re(e, r) {
  return Se(le, e, r);
}
function we(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ot(e) {
  return Be = ue = 1, at = H(le = e), z = 0, [];
}
function it(e) {
  return le = "", e;
}
function je(e) {
  return nt(Re(z - 1, cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function cn(e) {
  for (; (V = J()) && V < 33; )
    U();
  return we(e) > 2 || we(V) > 3 ? "" : " ";
}
function un(e, r) {
  for (; --r && U() && !(V < 48 || V > 102 || V > 57 && V < 65 || V > 70 && V < 97); )
    ;
  return Re(e, Fe() + (r < 6 && J() == 32 && U() == 32));
}
function cr(e) {
  for (; U(); )
    switch (V) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cr(V);
        break;
      case 40:
        e === 41 && cr(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function fn(e, r) {
  for (; U() && e + V !== 47 + 10; )
    if (e + V === 42 + 42 && J() === 47)
      break;
  return "/*" + Re(r, z - 1) + "*" + Ue(e === 47 ? e : U());
}
function ln(e) {
  for (; !we(J()); )
    U();
  return Re(e, z);
}
function dn(e) {
  return it(Ve("", null, null, null, [""], e = ot(e), 0, [0], e));
}
function Ve(e, r, n, a, o, i, u, l, d) {
  for (var h = 0, p = 0, y = u, R = 0, N = 0, C = 0, g = 1, A = 1, b = 1, m = 0, S = "", M = o, c = i, I = a, w = S; A; )
    switch (C = m, m = U()) {
      case 40:
        if (C != 108 && Y(w, y - 1) == 58) {
          sr(w += P(je(m), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        w += je(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        w += cn(C);
        break;
      case 92:
        w += un(Fe() - 1, 7);
        continue;
      case 47:
        switch (J()) {
          case 42:
          case 47:
            Me(pn(fn(U(), Fe()), r, n), d);
            break;
          default:
            w += "/";
        }
        break;
      case 123 * g:
        l[h++] = H(w) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            A = 0;
          case 59 + p:
            b == -1 && (w = P(w, /\f/g, "")), N > 0 && H(w) - y && Me(N > 32 ? jr(w + ";", a, n, y - 1) : jr(P(w, " ", "") + ";", a, n, y - 2), d);
            break;
          case 59:
            w += ";";
          default:
            if (Me(I = Fr(w, r, n, h, p, o, l, S, M = [], c = [], y), i), m === 123)
              if (p === 0)
                Ve(w, r, I, I, M, i, y, l, c);
              else
                switch (R === 99 && Y(w, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ve(e, I, I, a && Me(Fr(e, I, I, 0, 0, o, l, S, o, M = [], y), c), o, c, y, l, a ? M : c);
                    break;
                  default:
                    Ve(w, I, I, I, [""], c, 0, l, c);
                }
        }
        h = p = N = 0, g = b = 1, S = w = "", y = u;
        break;
      case 58:
        y = 1 + H(w), N = C;
      default:
        if (g < 1) {
          if (m == 123)
            --g;
          else if (m == 125 && g++ == 0 && sn() == 125)
            continue;
        }
        switch (w += Ue(m), m * g) {
          case 38:
            b = p > 0 ? 1 : (w += "\f", -1);
            break;
          case 44:
            l[h++] = (H(w) - 1) * b, b = 1;
            break;
          case 64:
            J() === 45 && (w += je(U())), R = J(), p = y = H(S = w += ln(Fe())), m++;
            break;
          case 45:
            C === 45 && H(w) == 2 && (g = 0);
        }
    }
  return i;
}
function Fr(e, r, n, a, o, i, u, l, d, h, p) {
  for (var y = o - 1, R = o === 0 ? i : [""], N = Er(R), C = 0, g = 0, A = 0; C < a; ++C)
    for (var b = 0, m = Se(e, y + 1, y = en(g = u[C])), S = e; b < N; ++b)
      (S = nt(g > 0 ? R[b] + " " + m : P(m, /&\f/g, R[b]))) && (d[A++] = S);
  return qe(e, r, n, o === 0 ? mr : l, d, h, p);
}
function pn(e, r, n) {
  return qe(e, r, n, hr, Ue(on()), Se(e, 2, -2), 0);
}
function jr(e, r, n, a) {
  return qe(e, r, n, yr, Se(e, 0, a), Se(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var n = "", a = Er(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function vn(e, r, n, a) {
  switch (e.type) {
    case Qt:
      if (e.children.length)
        break;
    case Xt:
    case yr:
      return e.return = e.return || e.value;
    case hr:
      return "";
    case tt:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case mr:
      e.value = e.props.join(",");
  }
  return H(n = ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function hn(e) {
  var r = Er(e);
  return function(n, a, o, i) {
    for (var u = "", l = 0; l < r; l++)
      u += e[l](n, a, o, i) || "";
    return u;
  };
}
function mn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function yn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var En = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = J(), o === 38 && i === 12 && (n[a] = 1), !we(i); )
    U();
  return Re(r, z);
}, gn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (we(o)) {
      case 0:
        o === 38 && J() === 12 && (n[a] = 1), r[a] += En(z - 1, n, a);
        break;
      case 2:
        r[a] += je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = J() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = U());
  return r;
}, bn = function(r, n) {
  return it(gn(ot(r), n));
}, Vr = /* @__PURE__ */ new WeakMap(), _n = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Vr.get(a)) && !o) {
      Vr.set(r, !0);
      for (var i = [], u = bn(n, i), l = a.props, d = 0, h = 0; d < u.length; d++)
        for (var p = 0; p < l.length; p++, h++)
          r.props[h] = i[d] ? u[d].replace(/&\f/g, l[p]) : l[p] + " " + u[d];
    }
  }
}, Sn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, wn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", xn = function(r) {
  return r.type === "comm" && r.children.indexOf(wn) > -1;
}, Rn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var u = !!n.parent, l = u ? n.parent.children : (
          // global rule at the root level
          o
        ), d = l.length - 1; d >= 0; d--) {
          var h = l[d];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (xn(h))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, st = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Cn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!st(n[a]))
      return !0;
  return !1;
}, Yr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Tn = function(r, n, a) {
  st(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Yr(r)) : Cn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Yr(r)));
};
function ct(e, r) {
  switch (tn(e, r)) {
    case 5103:
      return O + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return O + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return O + e + We + e + L + e + e;
    case 6828:
    case 4268:
      return O + e + L + e + e;
    case 6165:
      return O + e + L + "flex-" + e + e;
    case 5187:
      return O + e + P(e, /(\w+).+(:[^]+)/, O + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return O + e + L + "flex-item-" + P(e, /flex-|-self/, "") + e;
    case 4675:
      return O + e + L + "flex-line-pack" + P(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return O + e + L + P(e, "shrink", "negative") + e;
    case 5292:
      return O + e + L + P(e, "basis", "preferred-size") + e;
    case 6060:
      return O + "box-" + P(e, "-grow", "") + O + e + L + P(e, "grow", "positive") + e;
    case 4554:
      return O + P(e, /([^-])(transform)/g, "$1" + O + "$2") + e;
    case 6187:
      return P(P(P(e, /(zoom-|grab)/, O + "$1"), /(image-set)/, O + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return P(e, /(image-set\([^]*)/, O + "$1$`$1");
    case 4968:
      return P(P(e, /(.+:)(flex-)?(.*)/, O + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + O + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return P(e, /(.+)-inline(.+)/, O + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (H(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return P(e, /(.+:)(.+)-([^]+)/, "$1" + O + "$2-$3$1" + We + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~sr(e, "stretch") ? ct(P(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, H(e) - 3 - (~sr(e, "!important") && 10))) {
        case 107:
          return P(e, ":", ":" + O) + e;
        case 101:
          return P(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + O + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + O + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return O + e + L + P(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return O + e + L + P(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return O + e + L + P(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return O + e + L + e + e;
  }
  return e;
}
var On = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case yr:
        r.return = ct(r.value, r.length);
        break;
      case tt:
        return ce([_e(r, {
          value: P(r.value, "@", "@" + O)
        })], o);
      case mr:
        if (r.length)
          return an(r.props, function(i) {
            switch (nn(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([_e(r, {
                  props: [P(i, /:(read-\w+)/, ":" + We + "$1")]
                })], o);
              case "::placeholder":
                return ce([_e(r, {
                  props: [P(i, /:(plac\w+)/, ":" + O + "input-$1")]
                }), _e(r, {
                  props: [P(i, /:(plac\w+)/, ":" + We + "$1")]
                }), _e(r, {
                  props: [P(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Pn = [On], Nn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var A = g.getAttribute("data-emotion");
      A.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Pn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, u, l = [];
  u = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var A = g.getAttribute("data-emotion").split(" "), b = 1; b < A.length; b++)
        i[A[b]] = !0;
      l.push(g);
    }
  );
  var d, h = [_n, Sn];
  process.env.NODE_ENV !== "production" && h.push(Rn({
    get compat() {
      return C.compat;
    }
  }), Tn);
  {
    var p, y = [vn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? p.insert(g.return) : g.value && g.type !== hr && p.insert(g.value + "{}"));
    } : mn(function(g) {
      p.insert(g);
    })], R = hn(h.concat(o, y)), N = function(A) {
      return ce(dn(A), R);
    };
    d = function(A, b, m, S) {
      p = m, process.env.NODE_ENV !== "production" && b.map !== void 0 && (p = {
        insert: function(c) {
          m.insert(c + b.map);
        }
      }), N(A ? A + "{" + b.styles + "}" : b.styles), S && (C.inserted[b.name] = !0);
    };
  }
  var C = {
    key: n,
    sheet: new Zt({
      key: n,
      container: u,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: d
  };
  return C.sheet.hydrate(l), C;
}, ur = { exports: {} }, $ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function An() {
  if (Lr)
    return $;
  Lr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
  function S(c) {
    if (typeof c == "object" && c !== null) {
      var I = c.$$typeof;
      switch (I) {
        case r:
          switch (c = c.type, c) {
            case d:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case p:
                case C:
                case N:
                case u:
                  return c;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function M(c) {
    return S(c) === h;
  }
  return $.AsyncMode = d, $.ConcurrentMode = h, $.ContextConsumer = l, $.ContextProvider = u, $.Element = r, $.ForwardRef = p, $.Fragment = a, $.Lazy = C, $.Memo = N, $.Portal = n, $.Profiler = i, $.StrictMode = o, $.Suspense = y, $.isAsyncMode = function(c) {
    return M(c) || S(c) === d;
  }, $.isConcurrentMode = M, $.isContextConsumer = function(c) {
    return S(c) === l;
  }, $.isContextProvider = function(c) {
    return S(c) === u;
  }, $.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, $.isForwardRef = function(c) {
    return S(c) === p;
  }, $.isFragment = function(c) {
    return S(c) === a;
  }, $.isLazy = function(c) {
    return S(c) === C;
  }, $.isMemo = function(c) {
    return S(c) === N;
  }, $.isPortal = function(c) {
    return S(c) === n;
  }, $.isProfiler = function(c) {
    return S(c) === i;
  }, $.isStrictMode = function(c) {
    return S(c) === o;
  }, $.isSuspense = function(c) {
    return S(c) === y;
  }, $.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === R || typeof c == "object" && c !== null && (c.$$typeof === C || c.$$typeof === N || c.$$typeof === u || c.$$typeof === l || c.$$typeof === p || c.$$typeof === A || c.$$typeof === b || c.$$typeof === m || c.$$typeof === g);
  }, $.typeOf = S, $;
}
var k = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function $n() {
  return Wr || (Wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
    function S(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === R || typeof v == "object" && v !== null && (v.$$typeof === C || v.$$typeof === N || v.$$typeof === u || v.$$typeof === l || v.$$typeof === p || v.$$typeof === A || v.$$typeof === b || v.$$typeof === m || v.$$typeof === g);
    }
    function M(v) {
      if (typeof v == "object" && v !== null) {
        var ye = v.$$typeof;
        switch (ye) {
          case r:
            var ae = v.type;
            switch (ae) {
              case d:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ae;
              default:
                var re = ae && ae.$$typeof;
                switch (re) {
                  case l:
                  case p:
                  case C:
                  case N:
                  case u:
                    return re;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var c = d, I = h, w = l, He = u, Ce = r, Je = p, Ke = a, Te = C, q = N, K = n, ee = i, Oe = o, Pe = y, de = !1;
    function Ne(v) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), pe(v) || M(v) === d;
    }
    function pe(v) {
      return M(v) === h;
    }
    function Ae(v) {
      return M(v) === l;
    }
    function $e(v) {
      return M(v) === u;
    }
    function ke(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Ze(v) {
      return M(v) === p;
    }
    function Xe(v) {
      return M(v) === a;
    }
    function ve(v) {
      return M(v) === C;
    }
    function he(v) {
      return M(v) === N;
    }
    function te(v) {
      return M(v) === n;
    }
    function me(v) {
      return M(v) === i;
    }
    function ne(v) {
      return M(v) === o;
    }
    function Qe(v) {
      return M(v) === y;
    }
    k.AsyncMode = c, k.ConcurrentMode = I, k.ContextConsumer = w, k.ContextProvider = He, k.Element = Ce, k.ForwardRef = Je, k.Fragment = Ke, k.Lazy = Te, k.Memo = q, k.Portal = K, k.Profiler = ee, k.StrictMode = Oe, k.Suspense = Pe, k.isAsyncMode = Ne, k.isConcurrentMode = pe, k.isContextConsumer = Ae, k.isContextProvider = $e, k.isElement = ke, k.isForwardRef = Ze, k.isFragment = Xe, k.isLazy = ve, k.isMemo = he, k.isPortal = te, k.isProfiler = me, k.isStrictMode = ne, k.isSuspense = Qe, k.isValidElementType = S, k.typeOf = M;
  }()), k;
}
process.env.NODE_ENV === "production" ? ur.exports = An() : ur.exports = $n();
var kn = ur.exports, ut = kn, In = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Dn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ft = {};
ft[ut.ForwardRef] = In;
ft[ut.Memo] = Dn;
var Mn = !0;
function Fn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var lt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Mn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, jn = function(r, n, a) {
  lt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Vn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Yn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, zr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Ln = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Wn = /[A-Z]|^ms/g, dt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, gr = function(r) {
  return r.charCodeAt(1) === 45;
}, Ur = function(r) {
  return r != null && typeof r != "boolean";
}, or = /* @__PURE__ */ yn(function(e) {
  return gr(e) ? e : e.replace(Wn, "-$&").toLowerCase();
}), ze = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(dt, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Yn[r] !== 1 && !gr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var zn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Un = ["normal", "none", "initial", "inherit", "unset"], Bn = ze, qn = /^-ms-/, Gn = /-(.)/g, Br = {};
  ze = function(r, n) {
    if (r === "content" && (typeof n != "string" || Un.indexOf(n) === -1 && !zn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Bn(r, n);
    return a !== "" && !gr(r) && r.indexOf("-") !== -1 && Br[r] === void 0 && (Br[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(qn, "ms-").replace(Gn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var pt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function xe(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(pt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Hn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, u = n(e);
        return G = i, xe(e, r, u);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], d = n.replace(dt, function(p, y, R) {
          var N = "animation" + l.length;
          return l.push("const " + N + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Hn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += xe(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var u = n[i];
      if (typeof u != "object")
        r != null && r[u] !== void 0 ? a += i + "{" + r[u] + "}" : Ur(u) && (a += or(i) + ":" + ze(i, u) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(pt);
        if (Array.isArray(u) && typeof u[0] == "string" && (r == null || r[u[0]] === void 0))
          for (var l = 0; l < u.length; l++)
            Ur(u[l]) && (a += or(i) + ":" + ze(i, u[l]) + ";");
        else {
          var d = xe(e, r, u);
          switch (i) {
            case "animation":
            case "animationName": {
              a += or(i) + ":" + d + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Ln), a += i + "{" + d + "}";
          }
        }
      }
    }
  return a;
}
var qr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, vt;
process.env.NODE_ENV !== "production" && (vt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Gr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var u = r[0];
  u == null || u.raw === void 0 ? (o = !1, i += xe(a, n, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(zr), i += u[0]);
  for (var l = 1; l < r.length; l++)
    i += xe(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && u[l] === void 0 && console.error(zr), i += u[l]);
  var d;
  process.env.NODE_ENV !== "production" && (i = i.replace(vt, function(R) {
    return d = R, "";
  })), qr.lastIndex = 0;
  for (var h = "", p; (p = qr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    p[1];
  var y = Vn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: d,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Jn = function(r) {
  return r();
}, Kn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Zn = Kn || Jn, Ge = {}.hasOwnProperty, br = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Nn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (br.displayName = "EmotionCacheContext");
br.Provider;
var Xn = function(r) {
  return /* @__PURE__ */ dr(function(n, a) {
    var o = Wt(br);
    return r(n, o, a);
  });
}, ht = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ht.displayName = "EmotionThemeContext");
var Hr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Qn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Hr(n[1]);
}, ea = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ra = function(r) {
  return r.replace(/\$/g, "-");
}, ta = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Qn(n[a]);
      if (o) {
        if (ea.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ra(o);
      }
    }
}, fr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", lr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", mt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ge.call(n, o) && (a[o] = n[o]);
  if (a[fr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = ta(new Error().stack);
    i && (a[lr] = i);
  }
  return a;
}, na = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return lt(n, a, o), Zn(function() {
    return jn(n, a, o);
  }), null;
}, yt = /* @__PURE__ */ Xn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[fr], i = [a], u = "";
  typeof e.className == "string" ? u = Fn(r.registered, i, e.className) : e.className != null && (u = e.className + " ");
  var l = Gr(i, void 0, X.useContext(ht));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var d = e[lr];
    d && (l = Gr([l, "label:" + d + ";"]));
  }
  u += r.key + "-" + l.name;
  var h = {};
  for (var p in e)
    Ge.call(e, p) && p !== "css" && p !== fr && (process.env.NODE_ENV === "production" || p !== lr) && (h[p] = e[p]);
  return h.ref = n, h.className = u, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(na, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (yt.displayName = "EmotionCssPropInternal");
var Et = yt;
function Q(e, r, n) {
  return Ge.call(r, "css") ? Le.jsx(Et, mt(e, r), n) : Le.jsx(e, r, n);
}
function Ye(e, r, n) {
  return Ge.call(r, "css") ? Le.jsxs(Et, mt(e, r), n) : Le.jsxs(e, r, n);
}
const gt = fe`
  display: inline-block;
  line-height: 1.33;
  font-size: 12px;
  font-weight: 400;
`, bt = fe`
  margin-bottom: 4px;
  color: ${pr(`--${vr}-grayBlue-04`)};
`, aa = fe`
  font-size: 12px;
  margin-top: 4px;
  color: ${pr(`--${vr}-grayBlue-04`)};
`, _t = fe`
  font-size: 24px;
  font-weight: 500;
  color: ${pr(`--${vr}-grayBlue-02`)};
`;
function Jr(e, r) {
  const n = r ? 4 : 8, a = e ? `margin-right:${n}px;` : `margin-left:${n}px;`;
  return fe`
    display: inline-block;
    ${a + (r ? "font-size: 14px;" : "font-size: 18px;")}
  `;
}
const oa = fe`
  display: inline-block;
  direction: ltr;
`, ia = dr((e, r) => {
  const { title: n, value: a = 0, decimalSeparator: o = ".", format: i, groupSeparator: u = ",", loading: l, precision: d, suffix: h, prefix: p, extra: y, countUp: R, countFrom: N = 0, countDuration: C = 2e3, ...g } = e, [A, b] = Zr(a), m = Xr();
  function S(c = N, I = a) {
    c !== I && (m.current = Bt(c, Number(I), {
      duration: Math.floor(C / 1e3),
      ease: "easeOut",
      onUpdate: (w) => {
        b(w);
      },
      onComplete: () => {
        b(I);
      }
    }));
  }
  Qr(() => (e.countUp ? (m.current && m.current.stop(), A !== a ? S(Number(A), a) : S()) : b(a), () => {
    m.current && m.current.stop(), m.current = null;
  }), [a]), zt(r, () => ({
    onCountUp: S
  }));
  const M = Ut(() => {
    if (i)
      return se(A).format(i);
    let c = Number(A);
    if (!isFinite(c))
      return A;
    d !== void 0 && (c = c.toFixed(d));
    let [I, w] = String(c).split(".");
    return I = I.replace(/\B(?=(\d{3})+(?!\d))/g, u), w !== void 0 ? I + o + w : I;
  }, [i, a, u, o, d, A]);
  return Ye("div", { css: [gt, et(e)], ...rt(g), children: [n && Q("div", { css: bt, children: n }), Ye("div", { children: [Q(qt, { animation: !0, visible: !!l, text: { rows: 1, width: "100%" }, children: Ye("div", { css: _t, children: [p && Q("span", { css: Jr(!0, !Ir(p)), children: p }), Q("span", { css: oa, children: M.toString() }), h && Q("span", { css: Jr(!1, !Ir(h)), children: h })] }) }), y && Q("div", { css: aa, children: y })] })] });
});
ia.displayName = "Statistic";
const sa = [
  ["Y", 1e3 * 60 * 60 * 24 * 365],
  ["M", 1e3 * 60 * 60 * 24 * 30],
  ["D", 1e3 * 60 * 60 * 24],
  ["H", 1e3 * 60 * 60],
  ["m", 1e3 * 60],
  ["s", 1e3],
  ["S", 1]
  // million seconds
];
function ca(e, r) {
  let n = e;
  return sa.reduce((a, [o, i]) => {
    if (a.indexOf(o) !== -1) {
      const u = Math.floor(n / i);
      return n -= u * i, a.replace(new RegExp(`${o}+`, "g"), (l) => {
        const d = l.length;
        return u.toString().padStart(d, "0");
      });
    }
    return a;
  }, r);
}
const ua = dr((e, r) => {
  const { title: n, value: a = 0, format: o = "HH:mm:ss", onFinish: i, onChange: u, now: l = se(), start: d = !0, valueStyle: h, ...p } = e, y = se(l);
  y.isValid() || console.warn("the now prop is not valid!");
  const R = se(a) || se();
  R.isValid() || console.warn("the value prop is not valid!");
  const [N, C] = Zr(Math.max(R.diff(y, "millisecond"), 0)), g = Xr(void 0), A = () => {
    window.clearInterval(g.current), g.current = void 0;
  }, b = () => {
    g.current = window.setInterval(() => {
      const m = R.diff(se(), "millisecond"), S = Math.max(m, 0);
      u && u(S), m <= 0 && (A(), i && i()), C(S);
    }, 1e3 / 30);
  };
  return Qr(() => (!g.current && d && R.valueOf() >= Date.now() && b(), () => {
    A();
  }), [d]), Ye("div", { ref: r, css: [gt, et(e)], ...rt(p), children: [n && Q("div", { css: bt, children: n }), Q("div", { css: _t, style: h, children: ca(N, o) })] });
});
ua.displayName = "Countdown";
export {
  ua as Countdown,
  ia as Statistic
};
//# sourceMappingURL=index.js.map
